import { makeAutoObservable } from "mobx";

export enum Dialogs {
  AddOrderDialog = 'addOrderDialog',
  AddBatteryDialog = 'addBatteryDialog',
  AddBrandDialog = 'addBrandDialog',
}

export interface IDialogState {
  opened: boolean;
}

export enum AllowedSections {
  orders = 'orders',
}

export interface IFilter {
  searchTerm: string;
}

export class LayoutStorage {
  isSidebarOpen = true;
  isAddPartModalOpen = false;
  isSelectBrandDialogOpened = false;
  currentDialogsOpened = 0;
  isAddPartTypeModalOpened = false;
  isAddSupplierModalOpen = false;
  isAddItemDialogOpened = '';

  dialogs: Record<Dialogs, IDialogState> = {
    addOrderDialog: {
      opened: false,
    },
    addBatteryDialog: {
      opened: false,
    },
    addBrandDialog: {
      opened: false,
    },
  }

  filters: Record<AllowedSections, Record<string, IFilter>> = {
    orders: {}
  }


  constructor() {
    makeAutoObservable(this);
  }

  get isAddBrandDialogOpened() {
    return this.dialogs.addBrandDialog.opened;
  }

  toggleAddPartModalDialog = () => {
    this.isAddPartModalOpen = !this.isAddPartModalOpen;
  }

  toggleSelectBrandDialog = () => {
    this.isSelectBrandDialogOpened = !this.isSelectBrandDialogOpened;
  }
  toggleAddBrandDialog = () => {
    this.dialogs.addBrandDialog.opened = !this.dialogs.addBrandDialog.opened;
  }

  toggleAddPartTypeModalDialog = () => {
    this.isAddPartTypeModalOpened = !this.isAddPartTypeModalOpened;
  }

  closeAddPartTypeModalDialog = () => {
    this.isAddPartTypeModalOpened = false;
  }

  toggleAddSupplierModalDialog = () => {
    this.isAddSupplierModalOpen = !this.isAddSupplierModalOpen;
  }

  toggleAddItemDialog = (id: string) => {
    this.isAddItemDialogOpened = this.isAddItemDialogOpened ? '' : id;
  }

  toggleDialog = (dialogName: Dialogs, action?: 'open' | 'close') => {
    if (!Object.values(Dialogs).includes(dialogName)) {
      return;
    }
    if (action !== undefined) {
      this.dialogs[dialogName].opened = action === 'open';
    } else {
      this.dialogs[dialogName].opened = !this.dialogs[dialogName].opened;
    }

  }

  setSearchTerm = (section: AllowedSections, dataIndex: any, searchTerm: string) => {
    if (!this.filters[section]) {
      throw new Error(`Section ${section} is not defined in filters`);
    }
    if (!this.filters[section][dataIndex]) {
      this.filters[section][dataIndex] = {
        searchTerm,
      };
    }
    this.filters[section][dataIndex].searchTerm = searchTerm;
  }
}

const layoutStorage = new LayoutStorage();

export default layoutStorage;
